<header class="site-header">
  <div class="site-header__bar">
    <div class="brand-group">
      <a class="brand" routerLink="/" (click)="closeMenus()">
        <img src="assets/images/osterby_dack_och_allservice_logotyp_600x232.png" alt="Österbydäck & Allservice">
      </a>
      <span class="brand-divider" aria-hidden="true"></span>
      <a class="partner-link" href="https://www.firststop.se" target="_blank" rel="noopener" aria-label="First Stop (öppnas i ny flik)">
        <img class="brand-partner-logo" src="assets/images/firststop_2il.gif" alt="First Stop">
      </a>
    </div>

    <button
      type="button"
      class="nav-toggle"
      [class.nav-toggle--open]="menuOpen"
      (click)="toggleMenu()"
      [attr.aria-expanded]="menuOpen"
      aria-label="Öppna meny"
      aria-controls="site-nav">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <nav class="site-nav" id="site-nav" [class.site-nav--open]="menuOpen">
      <ul>
        <li>
          <a routerLink="/" routerLinkActive="is-active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMenus()">Hem</a>
        </li>

        <li class="has-dropdown" [class.is-open]="servicesOpen">
          <button
            type="button"
            class="nav-dropdown-toggle"
            routerLinkActive="is-active"
            [routerLinkActiveOptions]="{exact: false}"
            [class.is-active]="servicesOpen"
            (click)="toggleServices($event)"
            [attr.aria-expanded]="servicesOpen"
            aria-haspopup="true">
            Tjänster
            <svg class="chevron" width="11" height="7" viewBox="0 0 11 7" aria-hidden="true">
              <path d="M1 1l4.5 4.5L10 1" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <ul class="nav-dropdown-menu">
            <li><a routerLink="/service" routerLinkActive="is-active" (click)="closeMenus()">Service</a></li>
            <li><a routerLink="/tires" routerLinkActive="is-active" (click)="closeMenus()">Däck</a></li>
            <li><a routerLink="/storage" routerLinkActive="is-active" (click)="closeMenus()">Däckhotell &amp; Vinterförvaring</a></li>
          </ul>
        </li>

        <li><a routerLink="/openinghours" routerLinkActive="is-active" (click)="closeMenus()">Öppettider</a></li>
        <li><a routerLink="/aboutus" routerLinkActive="is-active" (click)="closeMenus()">Om oss</a></li>
        <li><a routerLink="/findus" routerLinkActive="is-active" (click)="closeMenus()">Hitta hit</a></li>
        <li class="nav-cta"><a routerLink="/contactus" routerLinkActive="is-active" (click)="closeMenus()">Kontakta oss</a></li>
      </ul>
    </nav>
  </div>

  <div class="partner-strip" aria-hidden="true"></div>
</header>
